import React from "react";
import { FiCheck, FiHeart, FiSmartphone } from "react-icons/fi";
import Button from "../common/Button";

const savedItems = [
  ["Ember & Oak Paprika", "/images/generated/pantry-paprika.png"],
  ["Cedar Grove Za’atar", "/images/generated/pantry-zaatar.png"],
  ["Dawn Harvest Saffron", "/images/generated/pantry-saffron.png"],
];

const PantryCompanion = () => (
  <section className="section pantry-companion">
    <div className="site-container pantry-companion__grid">
      <div className="pantry-companion__content">
        <p className="eyebrow">Your pantry companion</p>
        <h2>Save the flavors you want to cook next.</h2>
        <p>
          Build a practical shortlist, return on any device, and move a saved
          jar into your cart when the recipe calls for it.
        </p>
        <ul>
          <li>
            <FiCheck aria-hidden="true" /> Persistent wishlist
          </li>
          <li>
            <FiCheck aria-hidden="true" /> Recipe-to-cart shortcuts
          </li>
          <li>
            <FiCheck aria-hidden="true" /> Account API ready
          </li>
        </ul>
        <div className="pantry-companion__actions">
          <Button to="/wishlist">
            <FiHeart aria-hidden="true" /> Open wishlist
          </Button>
        </div>
      </div>
      <div className="pantry-companion__device" aria-hidden="true">
        <div className="pantry-companion__device-bar">
          <span />
          <strong>Saved pantry</strong>
          <FiSmartphone />
        </div>
        <div className="pantry-companion__device-list">
          {savedItems.map(([name, image]) => (
            <span key={name}>
              <img src={image} alt="" />
              <strong>{name}</strong>
              <FiHeart />
            </span>
          ))}
        </div>
        <small>3 flavors saved · ready whenever you are</small>
      </div>
    </div>
  </section>
);

export default PantryCompanion;
